import React from 'react';
import { Calendar } from '../../../../shared/assets/AppIcons';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';

function getDescription(filter) {
  if (filter === 'giorno') return 'Oggi';
  if (filter === 'settimana') return 'Ultimi 7 giorni';
  if (filter === 'mese') return 'Ultime 4 settimane';
  if (filter === 'trimestre') return 'Ultimi 3 mesi';
  return 'Tutti i dati';
}

export default function UsageByPeriodChart({ filter, data }) {
  return (
    <Card className="border-[var(--border)]">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Calendar className="text-[var(--primary)]" size={16} />
          Utilizzi per {filter === 'giorno' ? 'Ora' : filter === 'settimana' ? 'Giorno' : 'Periodo'}
        </CardTitle>
        <CardDescription>{getDescription(filter)}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--source-color-108)" />
              <XAxis dataKey="giorno" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip
                contentStyle={{ backgroundColor: 'var(--source-color-142)', border: '1px solid var(--source-color-108)', borderRadius: '8px' }}
                formatter={(value) => [`${value} utilizzi`, 'Utilizzi']}
              />
              <Bar dataKey="utilizzi" fill="var(--source-color-051)" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
